export default __webpack_public_path__ + "static/media/gratique.9d57399a.jpg";